import { cloneElement, isValidElement } from 'react';
import { ResponsiveWrapper } from '@/components';
import { VizPanelProps } from './model';
import { UseVizPanelContentLayoutProps, useVizPanelContentLayout } from './useVizPanelLayout';

interface VizPanelContentProps
  extends Pick<VizPanelProps, 'children' | 'width' | 'height'>,
    Pick<UseVizPanelContentLayoutProps, 'vizPanelChildrenLayout'> {}

export function VizPanelContent({ vizPanelChildrenLayout, width, height, children }: VizPanelContentProps) {
  // These values depend on information from the `Container` context, so need to be called farther
  // down in the react tree.
  const { needsResponsiveDimensions, ...dimensions } = useVizPanelContentLayout({
    vizPanelChildrenLayout,
    width,
    height,
  });

  if (children) {
    if (isValidElement(children)) {
      if (needsResponsiveDimensions) {
        return <ResponsiveWrapper>{children}</ResponsiveWrapper>;
      }

      return cloneElement(children, {
        ...dimensions,
      });
    }

    return children;
  }

  return null;
}
